import { Box, Chip, Typography } from '@mui/material';
import {
  type FieldType,
  FIELD_TYPE_CATEGORIES,
  getFieldTypeColor,
  getFieldTypeDisplayLabel,
} from './types';

interface FieldTypeChipSelectorProps {
  onFieldTypeClick: (type: FieldType) => void;
}

export const FieldTypeChipSelector = ({
  onFieldTypeClick,
}: FieldTypeChipSelectorProps) => (
  <Box>
    <Typography
      variant="body2"
      sx={{ color: 'text.secondary', mb: 2, display: 'block' }}
    >
      Click a field type to add it to your form:
    </Typography>
    {Object.entries(FIELD_TYPE_CATEGORIES).map(([category, types]) => (
      <Box key={category} sx={{ mb: 2 }}>
        <Typography
          variant="subtitle2"
          sx={{
            color: 'text.secondary',
            mb: 1,
            display: 'block',
            fontWeight: 'bold',
          }}
        >
          {category}
        </Typography>
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
          {types.map((type) => (
            <Chip
              key={type}
              label={getFieldTypeDisplayLabel(type)}
              onClick={() => onFieldTypeClick(type)}
              color={getFieldTypeColor(type)}
              variant="outlined"
              sx={{
                cursor: 'pointer',
                '&:hover': { opacity: 0.85 },
                transition: 'all 0.2s',
              }}
            />
          ))}
        </Box>
      </Box>
    ))}
  </Box>
);
